import { GenericDateFilterFactory } from "../../Common/_generics/GenericDateFilterFactory";

export const PMSLocationProtectLogsDateFilter = GenericDateFilterFactory("PMS_LOCATION_PROTECT_LOGS");
